var _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F917(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 23.8,
    fill: "#FCEA2B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fcea2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 62.1l-5.1 5.2c-4.472-3.459-10.46-4.395-14.25-8.76-.512-2.736-1.312-10.01 1.854-7.34 4.956-3.31 4.378 1.379 10.1 2.8h.2c-.634-2.772-1.709-2.625.4-4.7 3.594 3.941 3.542 9.586 6.8 12.8zM50 49.6c1.591.854.486 3.626.5 4.7 1.7-.5 4.9-2.4 6.9-4 1.595.047 7.958 1.281 5.8 3.4 0 0 1.2.4 0 3-.7.5-.2 2.4-1 3.4-4.136 4.135-11.06 3.117-13.4 7.3l-5.2-5.2c3.69-3.36 1.958-9.959 6.4-12.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M56.2 47C58 43.6 59 39.8 59 36c0-12.7-10.3-23-23-23S13 23.3 13 36c0 3.7.9 7.4 2.7 10.7 0 .1 0 .1.1.2M29.6 58.1c2.1.6 4.2.9 6.4.9 2.1 0 4.2-.3 6.2-.8M45.8 45.2c-5.7 4.7-13.9 4.7-19.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M31.7 33.4c-1-2.4-3.8-3.5-6.2-2.4-1.1.5-1.9 1.3-2.4 2.4M48.9 33.4c-1-2.4-3.8-3.5-6.2-2.4-1.1.5-1.9 1.3-2.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M28.3 61.7c-.896-.764-1.554-1.366-1.8-2.4-.243-2.983-1.549-5.769-2.8-8.1-.3-.5-.9-2-1.5-2.2-.9-.3-1.5 0-1.7 1.1s.6 3.3.8 3.9a47.83 47.83 0 01-6.4-4.1c-1.2-.7-2.2-.4-2.7.4-.2.3-.2.5-.3.7-1.5-1.1-2.6-.7-3.1 0-.5.6-.5 1.5-.1 2.1-.2.1-.4.3-.5.5-.6 1-.3 2.3.7 2.9.2.1.5.4.9.6-.1.1-.2.1-.2.2-.5.6-.5 1.6 0 2.2 1.6 2.8 9 4.9 11.5 5.5l1.8 1.8M48.6 66.8l1.8-1.8c2.5-.6 9.9-2.8 11.5-5.5.5-.6.5-1.6-.1-2.1-.1-.1-.1-.2-.2-.2.5-.3.8-.6.9-.6 1-.6 1.3-1.9.7-2.9-.1-.2-.3-.4-.5-.5.4-.6.4-1.5-.1-2.1s-1.6-1.1-3.1 0c0-.3-.1-.6-.3-.7-.5-.7-1.4-1.1-2.7-.4 0 0-.1 0-.1.1-1.9 1.6-4.1 2.9-6.3 4 .503-1.286 1.69-5.814-.6-5.1-.6.2-1.2 1.7-1.5 2.2-1.738 2.511-2.258 5.218-2.8 8.1.031 1.077-1.076 1.676-1.8 2.4"
  }))));
}
export default Svg1F917;